exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-1bf1a492] table tbody>tr.inactive{opacity:0.50}[data-v-1bf1a492] table .custom-button .btn .fa{margin-right:0}\n", ""]);

